module.exports = __webpack_public_path__ + "static/img/loding.d7f951b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/homeImages/loding.gif
// module id = 7S8K
// module chunks = 37